import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import { FONT_COLOUR_SCORE_TARGET, FONT_TITLE } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudLevelCountdown extends Phaser.Group {
  constructor(game) {
    super(game);

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.5 });
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    this.count = createTextField(this.game, FONT_TITLE, 350, FONT_COLOUR_SCORE_TARGET);
    this.count.y = 50;
    this.count.x = this.panel.width / 2;
    this.count.text = 3;
    this.container.add(this.count);

    // adjust panel height to match content
    this.panel.height = this.count.y + 500;

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.fixedToCamera = true;
    this.handleScreenResize();

    this.duration = 0;

    this.onComplete = new Phaser.Signal();
  }

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  update() {
    this.count.x = this.panel.width * 0.5 - this.count.width * 0.5;
    if (this.duration < 3000) {
      this.duration += this.game.time.elapsedMS;
      this.count.text = 3 - Math.floor(this.duration / 1000);
    } else if (!this.dispatchedComplete) {
      this.count.text = 0;
      this.dispatchedComplete = true;
      this.onComplete.dispatch();
    }
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    // super dupa
    super.destroy(true);
  }
}
